import {renderAppointmentDetailsTable, renderConfirmationContainer} from "../utils/templates";
import {t} from "../i18n";
import {isNonNullObject} from "../utils/helpers.js";

export default class ConfirmStep {
  constructor() {
    this.id = 'confirm';
    this.title_key = 'confirm_your_order'; // 'send_appointment' or 'confirm_your_order' or 'confirm_your_class'
  }

  init({ $, state, data, emit, api }) {
    this.$ = $;
    this.state = state;
    this.data = data;
    this.emit = emit;
    this.api = api;

    this.sub = null;
    if(this.data.subscriptions && this.data.subscriptions.length > 0 && isNonNullObject(this.state.selectedSubscription)) {
      this.sub = this.state.selectedSubscription;
    }
    this.title_key = this.state.isClass ? 'confirm_your_class' : 'confirm_your_order';
  }

  render(container) {
    const $html = this.$(
        renderConfirmationContainer(
            {
              config: this.data.config,
              isClass: this.state.isClass ?? false
            }
        )
    );
    const $sendBtn = this.$('#send-appointment', $html);
    container.html($html);

    $sendBtn.on('click', e => {
      e.preventDefault();

      const btnStatus = $sendBtn.attr('disabled');
      console.log('btnStatus', btnStatus);
      if(btnStatus == 'disabled') {
        return; // button is disabled
      }
      let $notesInput = $html.find('.confirmation-message #notes');
      let dataToSend = {
        employeeId:    this.state.selectedEmployee,
        serviceId:     this.state.selectedServices,
        locationId:    this.state.selectedLocation,
        date:          this.state.date,
        startAt:       this.state.startAt,
        endAt:         this.state.endAt,
        // pending:       this.state.pending,
        // appointmentId: this.state.appointmentId,
        phone: bwAuth?.state?.phone || null,
        notes: $notesInput.length ? $notesInput.val() : '',
        noAccount: bwAuth?.state?.noAccount || false,
        isAuth: bwAuth?.isAuth || false
      };
      // reschedule
      if(this.state.appointmentId) {
        dataToSend.pending       = this.state.pending;
        dataToSend.appointmentId = this.state.appointmentId;
      }

      if(this.state.isClass) {
        dataToSend.isClass = true;
        dataToSend.classId = this.state.selectedClass;
      }
      if(this.state.selectedSubscription) {
        dataToSend.subscriptionId = this.state.selectedSubscription.id;
      }
      if(this.state.bookingName) {
        dataToSend.bookingName = this.state.bookingName;
      }
      $sendBtn.attr('disabled', 'disabled');
      $sendBtn.addClass('anim-spinner');
      $(`.field-error`, container).hide();

      this.api.post(this.data.apiRoutes.storeAppointment, {
        data:dataToSend,
        success: (data) => {
          if(data?.requires_validation) {
            console.log('Appointment not valid.');
          }
          this.state.appointmentLink = data.appLink ?? '';
          if(!this.sub && data && data.hasOwnProperty('redirect_url')) {
            this.emit('finish_with_redirect', data.redirect_url);
          } else {
            // if(this.data.config.use_deposit) { console.log('No redirect.'); }
            this.emit('finish_with_thanks', data);
          }
          $sendBtn.removeClass('anim-spinner');
          $sendBtn.removeAttr('disabled'); // not required?
        },
        error: (err) => {
          console.warn(err);
          if(err.data && err.data.error) {
            const $el = $(`.field-error.field-generic-error`, container);
            $el.text(err.data.error);
            $el.show();
          }
          $sendBtn.removeClass('anim-spinner');
          setTimeout(function () {
            $sendBtn.removeAttr('disabled')
          }, 5000);
        }

      })
    })

    this.api.get(this.data.apiRoutes.getAppointmentSummary, {
      data: {
        data: {
          selectedClass: this.state.selectedClass ?? null,
          selectedEmployeeId: this.state.selectedEmployee,
          selectedServiceId: [...this.state.selectedServices],
        }
      },
      success: (data) => {
        this.state.appointmentSummaryData = data;

        const $detailsTable = $html.find('.confirmation-details-table');
        renderAppointmentDetailsTable({
          table: $detailsTable,
          state: this.state
        });

        if (!!this.sub) {
          $detailsTable.append(`<tr><th class="text-left text-nowrap">${t('subscription.confirm_label')}:</th><td>${this.sub.title}</td></tr>`);
        }

        if (!this.sub && this.data.config.use_deposit && data.depositValue) {
          $detailsTable.append(`<tr><th class="text-left text-nowrap">${t('deposit_required')}:</th><td>${data.depositValue} ${data.depositCurrency}</td></tr>`);
          $sendBtn.first().text(t('finish_with_deposit'));
        } else {
          $sendBtn.first().text(t('finish'));
        }
      },
      error: (err) => {
        console.warn(err);
      }
    })
  }
};